<template>
    <tr v-loading="isLoading">
        <td></td>
        <td>
            <Select2 v-model="category" :options="category_select" :id="'category' + _uid" :settings="{width: '100%'}"/>
            <has-error :form="form" field="category" class="d-block"/>
            <has-error :form="form" field="platform_id" class="d-block"/>
            <has-error :form="form" field="car_id" class="d-block"/>
        </td>
        <td>
            <input style="width: 100px" type="number" class="form-control" :id="'amount' + _uid" v-model="amount" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
            <has-error :form="form" field="amount" class="d-block"/>
        </td>
        <td></td>
        <td>
            <input type="text" class="form-control" :id="'text' + _uid" v-model="comment">
            <has-error :form="form" field="comment" class="d-block"/>
        </td>
        <td></td>
        <td class="table-light border-left text-right text-nowrap">
            <button @click="obj && obj.id ? update() : create()" class="btn btn-sm btn-primary">Сохранить</button>
            <button @click="cancel()" class="btn btn-sm btn-light"><i class="fas fa-times text-primary"></i></button>
        </td>
    </tr>
</template>

<script>
import OperationCategoryData from "../../../plugins/operation_category_data";
import Form from "vform";

export default {
    name: "VirtualOperationForm",
    props: {
        obj: {
            type: Object,
            required: true,
        }
    },
    data: () => ({
        form: new Form({}),
        isLoading: false,

        platform_id: null,
        car_id: null,
        category: null,
        amount: null,
        comment: null,
    }),
    mounted() {
        this.loadObj(this.obj);
    },
    watch:{
        obj(val) {
            this.loadObj(val);
        }
    },
    computed:{
        category_select() {
            let items = OperationCategoryData
                .onlyFor('virtual_by_car', 'passive')
                .map(o => ({id: o.id, text: o.name}));

            return _.sortBy(items, ['text'])
        }
    },
    methods: {
        loadObj(o) {
            this.platform_id = o.platform_id;
            this.car_id = o.car_id;
            this.comment = o.comment;
            if (o.category) this.category = o.category;
            if (o.amount) this.amount = o.amount / 100;
        },
        validate() {
            this.form = new Form({
                platform_id: this.platform_id,
                car_id: this.car_id,
                category: this.category,
                amount: this.amount,
                comment: this.comment,
                balance_type: 'virtual_by_car',
                direction: 'passive',
            })
            return true;
        },
        create() {
            let self = this;
            self.isLoading = true;
            this.validate();
            this.form.post('/api/operations/virtual_by_car')
                .then(response => {
                    self.isLoading = false;
                    self.$emit('created', response.data);
                })
                .catch(() => {
                    self.isLoading = false;
                })
        },
        update() {
            let self = this;
            self.isLoading = true;
            this.validate();
            this.form.put('/api/operations/virtual_by_car/' + this.obj.id)
                .then(response => {
                    self.isLoading = false;
                    self.$emit('updated', response.data);
                })
                .catch(() => {
                    self.isLoading = false;
                })
        },
        cancel() {
            this.$emit('cancel');
        },
    }
}
</script>

<style scoped>

</style>
